module.exports = __webpack_public_path__ + "img/coming_soon.3db3fd03.svg";